import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCz4gtelD9VRprd1yZVs1EtPOODpH7Vvgc",
  authDomain: "gobrummi.firebaseapp.com",
  databaseURL: "https://gobrummi-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gobrummi",
  storageBucket: "gobrummi.appspot.com",
  messagingSenderId: "714777654393",
  appId: "1:714777654393:web:934b374b571e18fbf190a8",
  measurementId: "G-JQSGV33RSP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app;
